module.exports = __webpack_public_path__ + "img/app_logo.ae91ca6c.jpeg";